import { render, staticRenderFns } from "./affiliateLink.vue?vue&type=template&id=0a75429f&scoped=true"
import script from "./affiliateLink.vue?vue&type=script&lang=js"
export * from "./affiliateLink.vue?vue&type=script&lang=js"
import style0 from "./affiliateLink.vue?vue&type=style&index=0&id=0a75429f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a75429f",
  null
  
)

export default component.exports